import MutateCreateOrUpdateProperty from './../graphql/mutations/MutateCreateOrUpdateProperty';
import { GLOBAL_ERROR } from './../components/GlobalError/GlobalError';
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    updateVehicleApplication: async function (value, propertyFirst, propertySecond = null, propertyThird = null) {
      return await this.$apollo
        .mutate({
          mutation: MutateCreateOrUpdateProperty,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            params: {
              value: value,
              propertyFirst: propertyFirst,
              propertySecond: propertySecond,
              propertyThird: propertyThird
            }
          }
        })
        .then((data) => {
          this.updateVehicleApplicationState({
            value: value,
            propertyFirst: propertyFirst,
            propertySecond: propertySecond,
            propertyThird: propertyThird
          });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    capitalizeFirstLetter(string) {
      if (string && string.length) return string.charAt(0).toUpperCase() + string.slice(1);
      else return '';
    }
  }
};
